import React from "react";
import IconStyle from "./CloseIcon.module.css";

const XMark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-x"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

/**
 * The X affordance. Given an onClick it renders a real button, so it responds to
 * the mouse and the keyboard; previously the prop was dropped on the floor and
 * every `<CloseIcon onClick={...} />` was inert. Callers that wrap the icon in
 * their own clickable element pass no onClick and get the plain icon as before.
 */
const CloseIcon = ({ onClick, label = "Clear" }) => {
  if (!onClick) {
    return (
      <span className={IconStyle.icon}>
        <XMark />
      </span>
    );
  }

  return (
    <button
      // type is explicit: this sits inside a form and must never submit it
      type="button"
      aria-label={label}
      onClick={onClick}
      className={`${IconStyle.icon} ${IconStyle.button}`}
    >
      <XMark />
    </button>
  );
};

export default CloseIcon;
